import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { background, divider, text, blue } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { rounded } from "@/theme/variables";

type TVocabularySummaryCardProps = {
  masteredCount: number;
};

export const VocabularySummaryCard: FC<TVocabularySummaryCardProps> = ({ masteredCount }) => {
  const { t } = useTranslation();

  return (
    <Stack
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      gap={2}
      sx={{
        bgcolor: background.white,
        border: `1px solid ${divider.middle}`,
        borderRadius: rounded.xs,
        py: 1.5,
        px: 2,
      }}
    >
      <Typography sx={{ ...typography.body14Semi, color: text.secondary }}>{t("vocabulary.masteredWords")}</Typography>
      <Stack direction="row" alignItems="baseline" gap={0.5}>
        <Typography
          sx={{
            fontSize: "32px",
            lineHeight: "150%",
            fontWeight: 700,
            color: blue[80],
          }}
        >
          {masteredCount}
        </Typography>
        <Typography sx={{ ...typography.body14Semi, color: text.secondary }}>{t("vocabulary.wordUnit")}</Typography>
      </Stack>
    </Stack>
  );
};
